function CustomerDetailHeader({
  cliente = {},
  primaryButtonStyle,
  secondaryButtonStyle,
  onNewPlant,
  onEditCustomer,
}) {

  const formatCustomerType = (value) => {
  const labels = {
    privato: "Privato",
    azienda: "Azienda",
    ente_pubblico: "Ente pubblico",
    condominio: "Condominio",
    hotel: "Hotel",
    industria: "Industria",
    studio_professionale: "Studio professionale",
    altro: "Altro",
  };

  return labels[value] || value || "—";
};

  if (!cliente || !cliente.id) {
    return null;
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "16px",
          marginBottom: "24px",
        }}
      >
        <div>
         <h1
  style={{
    fontSize: "42px",
    fontWeight: 800,
    color: "#173a63",
    marginBottom: "8px",
    lineHeight: 1.1,
  }}
>
  {`${cliente.first_name || ""} ${cliente.last_name || ""}`.trim() ||
  cliente.company_name ||
  "Cliente"}
</h1>

<p
  style={{
    color: "#4b5563",
    marginTop: 0,
  }}
>
  Anagrafica, impianti, interventi e storico attività
</p> 
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <button
            style={primaryButtonStyle}
            onClick={onNewPlant}
          >
            + Nuovo impianto
          </button>

          <button
            style={secondaryButtonStyle}
            onClick={onEditCustomer}
          >
            Modifica cliente
          </button>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "14px",
          marginBottom: "28px",
        }}
      >
        {/* TELEFONO */}
        <div
          style={{
            background: "#f8fbff",
            borderRadius: "12px",
            padding: "14px",
          }}
        >
          <div
            style={{
              color: "#64748b",
              fontSize: "13px",
            }}
          >
            Telefono
          </div>

          {cliente.phone ? (
            <a
              href={`tel:${cliente.phone}`}
              style={{
                color: "#0f3c75",
                fontWeight: 700,
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              {cliente.phone}
            </a>
          ) : (
            <strong>—</strong>
          )}
        </div>

        {/* EMAIL */}
        <div
          style={{
            background: "#f8fbff",
            borderRadius: "12px",
            padding: "14px",
          }}
        >
          <div
            style={{
              color: "#64748b",
              fontSize: "13px",
            }}
          >
            Email
          </div>

          {cliente.email ? (
            <a
              href={`mailto:${cliente.email}`}
              style={{
                color: "#0f3c75",
                fontWeight: 700,
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              {cliente.email}
            </a>
          ) : (
            <strong>—</strong>
          )}
        </div>

        {/* CITTÀ */}
        <div
          style={{
            background: "#f8fbff",
            borderRadius: "12px",
            padding: "14px",
          }}
        >
          <div
            style={{
              color: "#64748b",
              fontSize: "13px",
            }}
          >
            Città
          </div>

          <strong>{cliente.city || "—"}</strong>
        </div>

        {/* CODICE FISCALE */}
        <div
          style={{
            background: "#f8fbff",
            borderRadius: "12px",
            padding: "14px",
          }}
        >
          <div
            style={{
              color: "#64748b",
              fontSize: "13px",
            }}
          >
            Codice fiscale
          </div>

          <strong>{cliente.fiscal_code || "—"}</strong>
        </div>

        <div
  style={{
    background: "#f8fbff",
    borderRadius: "12px",
    padding: "14px",
  }}
>
  <div
    style={{
      color: "#64748b",
      fontSize: "13px",
    }}
  >
    Tipo cliente
  </div>

  <strong>{formatCustomerType(cliente.customer_type)}</strong>
</div>

<div
  style={{
    background: "#f8fbff",
    borderRadius: "12px",
    padding: "14px",
  }}
>
  <div
    style={{
      color: "#64748b",
      fontSize: "13px",
    }}
  >
    Categoria cliente
  </div>

  <strong>{cliente.customer_category || "—"}</strong>
</div>

<div
  style={{
    background: "#f8fbff",
    borderRadius: "12px",
    padding: "14px",
  }}
>
  <div
    style={{
      color: "#64748b",
      fontSize: "13px",
    }}
  >
    Partita IVA
  </div>

  <strong>{cliente.vat_number || "—"}</strong>
</div>

<div
  style={{
    background: "#f8fbff",
    borderRadius: "12px",
    padding: "14px",
  }}
>
  <div
    style={{
      color: "#64748b",
      fontSize: "13px",
    }}
  >
    PEC
  </div>

  <strong>{cliente.pec || "—"}</strong>
</div>

<div
  style={{
    background: "#f8fbff",
    borderRadius: "12px",
    padding: "14px",
  }}
>
  <div
    style={{
      color: "#64748b",
      fontSize: "13px",
    }}
  >
    Codice SDI / Univoco
  </div>

  <strong>{cliente.sdi_code || "—"}</strong>
</div>

      </div>
    </>
  );
}

export default CustomerDetailHeader;